import client from "api/config";
import { convertNum } from "helper/convert-num";

//////////////////// about_us ////////////////////
const aboutUsUrl = "/about_us";
// get aboutus
export const getaboutUsRequest = () => client.get(aboutUsUrl);

/////////////// update about us ////////////////
export const updateAboutUsRequest = (values, onUploadProgress) => {
  const formData = new FormData();

  values.text && formData.append("text", values.text);
  values.instagram && formData.append("instagram", values.instagram);
  values.whatsapp && formData.append("whatsapp", values.whatsapp);
  values.email && formData.append("email", values.email);
  values.telegram && formData.append("telegram", values.telegram);
  values.address && formData.append("address", values.address);
  values.phone_number1 &&
    formData.append("phone_number1", values.phone_number1);
  formData.append("alt", values.alt);
  formData.append("meta_description", values.meta_description);
  formData.append("keyword", values.keyword);
  values.phone_number2 &&
    formData.append("phone_number2", values.phone_number2);
  !values.main_image.isWeb &&
    formData.append("main_image", values.main_image.url);
  values.video.isChanged && formData.append("video", values.video.url);

  formData.append("_method", "put");

  return client.post(`/admin${aboutUsUrl}`, formData, {
    onUploadProgress: (progress) =>
      onUploadProgress((progress.loaded / progress.total) * 100),
  });
};
